import React, { useEffect, useState } from "react";
import styled from "styled-components";

interface selectType {
  options: any;
  defaultValue: any;
  onChangeValue: any;
}

const DropdownSelect = ({
  options,
  defaultValue,
  onChangeValue,
}: selectType) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<any>(defaultValue);

  const handleSelectClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option: any) => {
    setSelectedOption(option);
    onChangeValue(option);
    setIsOpen(false);
  };

  useEffect(() => {
    setSelectedOption(defaultValue);
  }, [defaultValue]);

  return (
    <Style>
      <div className="selector">
        <div className="selectHeader" onClick={handleSelectClick}>
          <h2>{selectedOption.name}</h2>
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_down_grey.svg`}
            alt="버튼"
          />
        </div>
        {isOpen && (
          <ul className="selectList">
            {options.map((option: any) => (
              <li
                key={option.key}
                onClick={() => handleOptionClick(option)}
                className={`selectItem ${
                  option.value === selectedOption.value && "selected"
                }`}
              >
                {option.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </Style>
  );
};
export default DropdownSelect;

export const Style = styled.div`
  /* @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  } */

  .selector {
    position: relative;
    /* max-width: 120px; */
    margin: 1px;
    padding: 10px 0;
    background: #fff;
    font-weight: 600;
    color: #515151;
    border-radius: 0 0 5px 5px;
  }
  .selectHeader {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    margin-left: 12px;
    white-space: nowrap;

    h2 {
      width: 100%;
      font-size: 18px;
      line-height: 20px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    img {
      width: 12px;
      margin-left: auto;
    }
  }

  .selectList {
    position: absolute;
    width: 100%;
    max-height: 240px;
    padding: 10px 0 0 0;
    margin: 0 -1px;
    overflow-y: auto;
    list-style: none;
    border: 1px solid #4dd2ae;
    border-top: none;
    box-sizing: content-box;
    border-radius: 0px 0px 5px 5px;
    box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.25);
    background: #fff;
    z-index: 10;

    .selectItem {
      padding: 10px;
      font-weight: 600;
      font-size: 18px;
      line-height: 20px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      text-align: center;
    }
    .selectItem:hover {
      background: #ecf5f3;
    }
    .selectItem.selected {
      background: #4dd2ae;
      color: #ffffff;
    }
  }
  ::-webkit-scrollbar {
    display: none;
  }
`;
